import { render, staticRenderFns } from "./add-renew-contract.vue?vue&type=template&id=c526b7c2&"
import script from "./add-renew-contract.vue?vue&type=script&lang=js&"
export * from "./add-renew-contract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports